import * as types from './actionTypes';  
import createAdminApi from '../api/createAdminApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCreateAdmin(request) {

  return {
    type: types.DO_CREATE_ADMIN, 
    request
  };
}

export function doCreateAdminRes(data) {  
  return {
    type: types.DO_CREATE_ADMIN_RES, 
    data
  };
}

export function submitCreateAdminForm(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      createAdminApi.doCreateAdmin(request).then(data => {
        dispatch(doCreateAdminRes(data));
        dispatch(doCreateAdminRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}